var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('img',{attrs:{"src":require('./hermes.png'),"alt":"spinner","id":"image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }